/**
 * Generate a fresh Vocal Cord API key client-side.
 *
 * Format: `vc_<43 url-safe-base64 chars>` (32 random bytes -> base64url-no-pad).
 * Uses `crypto.getRandomValues` which is cryptographically secure.
 *
 * The key never leaves the browser until the user's AI agent calls our API
 * with it as the bearer token. The first authenticated MCP call implicitly
 * provisions the account on the backend, so issuing a key needs no
 * round-trip and no signup form.
 */
export function generateApiKey(): string {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  let bin = '';
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
  const b64 = btoa(bin)
    .replaceAll('+', '-')
    .replaceAll('/', '_')
    .replaceAll('=', '');
  return `vc_${b64}`;
}
